<template>
  <div v-if="user.id">
    <ClientEvaluationForm />
  </div>
</template>

<script>
import ClientEvaluationForm from '@/components/client-evaluation/form.vue'
import { mapState } from 'vuex'

export default {
  components: {
    ClientEvaluationForm
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
}
</script>